import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.regexp.replace.js";
import { getDomainName } from 'utils/deploymentInfo';
var getApiEndpoint = function getApiEndpoint(location) {
  try {
    var url = new URL(location || window.location.href);
    if (url.hostname.includes('staging')) {
      return url.origin.replace('ui', 'api').replace('http://', 'https://');
    }
    if (url.hostname.includes('localhost') || url.hostname.includes('127.0.0.1')) {
      return 'http://localhost:3000';
    }
    var domainName = getDomainName();
    return "https://api.".concat(domainName);
  } catch (error) {
    console.error('Failed to get API endpoint.');
    console.error(error);
  }
};
export default getApiEndpoint;